<template>
  <tr v-if="rate">
    <th class="sheet-header text-truncate text-capitalize" style="border-left: 2px solid white">
      <v-row align="center" no-gutters class="flex-nowrap">
        <v-btn class="mr-1" icon x-small @click="$set(rate, 'show', !rate.show)">
          <v-icon small>mdi-chevron-down</v-icon>
        </v-btn>

        <div style="max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{rate.name}}
          <sub class="grey--text">(ID: {{rate.id}})</sub>
        </div>

        <v-tooltip right small>
          <template v-slot:activator="{ on }">
            <v-icon v-if="rate.type==='sale'" v-on="on" class="ml-1" small>mdi-alpha-s-box</v-icon>
            <v-icon v-if="rate.type==='cost'" v-on="on" class="ml-1" small>mdi-alpha-c-box</v-icon>
            <v-icon v-if="rate.type==='offer'" v-on="on" class="ml-1" small>mdi-alpha-o-box</v-icon>
          </template>
          <span v-if="rate.type==='sale'">Sale</span>
          <span v-if="rate.type==='cost'">Cost</span>
          <span v-if="rate.type==='offer'">Offer</span>
        </v-tooltip>

      </v-row>
    </th>
    <td class="sheet-cell text-center" v-for="(price, index) in prices" :key="index">
      <template v-if="rate.static.editable_pricings">
        <v-progress-circular v-if="price.pu" size="12" width="2" indeterminate/>
        <input v-else v-model.lazy="price.price" type="number" class="sheet-input" @change="update(price)"/>
      </template>
      <template v-else>
        <input v-model.lazy="price.price" class="sheet-input" style="background-color: transparent; outline-color: transparent" readonly/>
      </template>


    </td>
  </tr>
</template>


<script>
  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      rate: null,
      prices: null
    },
    methods: {

      async update(data) {
        try {
          this.$set(data, 'pu', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
          await this.$store.dispatch('alert/error', 'Ultima modificare nu s-a salvat!');
        } finally {
          this.$set(data, 'pu', false);
        }
      }

    }
  }
</script>


<style scoped>
  @import '../sheet.css';
</style>